import * as React from "react";
import { GeneralModal } from "../Common/GeneralModal/GeneralModal";
import { ErrorStep } from "../AddRecipientFlow/Steps/ErrorStep";
import { ScaVerify } from "../ScaAirwallex/ScaVerify";
import { useLoader } from "../Common/GeneralLoader/GeneralLoaderProvider";
import { EditBeneficiaryFormStep } from "./Steps/EditBeneficiaryFormStep";
import { EditBeneficiaryConfirmStep } from "./Steps/EditBeneficiaryConfirmStep";
import { EditBeneficiarySuccessStep } from "./Steps/EditBeneficiarySuccessStep";
import { getRecipientDetailsApi, editRecipientApi } from "../../api/api";
import { drupalSettings } from "../../utils/config";

export function EditBeneficiaryFlow({ beneficiaryId }) {
  const [step, setStep] = React.useState(1);
  const [open, setOpen] = React.useState(true);
  const [payload, setPayload] = React.useState({
    beneficiaryId,
  });
  /** Avoid mounting the Airwallex step until REST has merged beneficiaryFormData (state updates async). */
  const [detailsLoaded, setDetailsLoaded] = React.useState(false);
  const { showLoader, hideLoader } = useLoader();

  React.useEffect(() => {
    const fetchDetails = async () => {
      if (!beneficiaryId) {
        setStep(-1);
        setDetailsLoaded(true);
        return;
      }
      showLoader();
      try {
        const response = await getRecipientDetailsApi({
          yatchId: drupalSettings?.user?.yacht_id,
          recipientId: beneficiaryId,
        });

        delete response?.payload?.sca_exemptible;

        setPayload((prev) => ({
          ...prev,
          beneficiaryId,
          beneficiaryFormData: response?.payload || {},
          recipientName: response?.recipient_name || response?.title || "",
        }));
      } catch (e) {
        setStep(-1);
      } finally {
        hideLoader();
        setDetailsLoaded(true);
      }
    };
    fetchDetails();
  }, [beneficiaryId]);

  const getStepComponent = (s) => {
    switch (s) {
      case -1:
        return <ErrorStep />;
      case 0:
        return <EditBeneficiarySuccessStep />;
      case 1:
        return <EditBeneficiaryFormStep payload={payload} setPayload={setPayload} setStep={setStep} />;
      case 2:
        return <EditBeneficiaryConfirmStep payload={payload} setPayload={setPayload} setStep={setStep} />;
      case 2.1:
        return (
          <ScaVerify
            key={2.1}
            scaSessionCode={payload?.scaSessionCode}
            setStep={setStep}
            payload={payload}
            setPayload={setPayload}
            onCancel={() => setOpen(false)}
            onVerificationSucceed={async (result) => {
              const requestPayload = payload?._editRecipientRequest;
              if (!requestPayload || !result?.token) {
                setStep(-1);
                return;
              }
              showLoader();
              try {
                const response = await editRecipientApi(requestPayload, {
                  scaToken: result.token,
                });
                if (response?.result) {
                  jQuery(".view-bank-recipient").trigger("RefreshView");
                  setStep(0);
                } else {
                  setStep(-1);
                }
              } catch {
                setStep(-1);
              } finally {
                hideLoader();
              }
            }}
            onVerificationFailed={() => setStep(-1)}
          />
        );
      default:
        return <ErrorStep />;
    }
  };

  const stepClass = [
    "add-recipient-popup",
    step === 0 ? "has-success" : step === -1 ? "has-error" : `step-${step}`,
    step === 2 ? "edit-beneficiary-summary-modal" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <GeneralModal
      open={open}
      setOpen={setOpen}
      className={stepClass}
      showCloseIcon={step !== 0}
    >
      {detailsLoaded ? getStepComponent(step) : null}
    </GeneralModal>
  );
}
